package todo.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.Div

@Page(routeOverride = "removeUser")
@Composable
fun RemoveUserPage() {
    var email by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
    var message by remember { mutableStateOf<String?>(null) }
    var error by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    Div(attrs = {
        // ...existing code...
    }) {
        // Header
        SpanText(
            "Delete Account",
            modifier = Modifier
                .fontWeight(700)
                .fontSize(20.px)
                .margin(bottom = 12.px)
        )

        // Email input
        TextInput(
            text = email,
            onTextChange = { email = it },
            placeholder = "Enter your email",
            modifier = Modifier
                .width(320.px)
                .margin(bottom = 8.px)
        )

        // Submit button
        Button(
            onClick = {
                error = null
                message = null
                val trimmed = email.trim()
                if (trimmed.isEmpty() || !trimmed.contains("@")) {
                    error = "Please enter a valid email."
                    return@Button
                }
                isLoading = true
                scope.launch {
                    try {
                        val res = window.fetch(
                            "https://bookbrief.docspot.pt:444/api/delete-account",
                            js("({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: trimmed }) })")
                        ).await()
                        val ok = res.ok
                        val text = res.text().await()
                        if (ok) {
                            message = "Account deletion requested. If the email exists, it will be processed."
                            email = ""
                        } else {
                            error = text.ifBlank { "Failed to request account deletion." }
                        }
                    } catch (e: dynamic) {
                        error = "Network error. Please try again."
                    } finally {
                        isLoading = false
                    }
                }
            },
            enabled = !isLoading,
            modifier = Modifier
                .margin(top = 8.px)
        ) {
            SpanText(if (isLoading) "Submitting..." else "Submit")
        }

        // Feedback
        if (message != null) {
            SpanText(
                message!!,
                modifier = Modifier
//                    .color(rgb(0, 128, 0))
                    .margin(top = 8.px)
            )
        }
        if (error != null) {
            SpanText(
                error!!,
                modifier = Modifier
//                    .color(rgb(200, 0, 0))
                    .margin(top = 8.px)
            )
        }
    }
}
